/**
 * My Alpha: the MyAlpha landing page, beside the sidebar. AppLayout drops the
 * top bar, breadcrumb and page padding on this route (FLUSH_ROUTES) so the
 * page fills the main column.
 */

import { LandingDraftPage } from './LandingDraftPage';
import { ThemeProvider } from './theme';
import './tokens.css';
import './embed.css';

export default function MyAlpha() {
  return (
    <ThemeProvider>
      <LandingDraftPage />
    </ThemeProvider>
  );
}
